import Helper from './Helper';

class Progressbar {
  constructor(config = {}) {
    const {
      progressbars,
    } = config;
    this.progressbars = Array.prototype.slice.call(document.querySelectorAll(progressbars));
    this.currentEl = null;
    if(this.progressbars && this.progressbars.length !== 0){
      this.bindEvents();
    }
  }

  bindEvents() {
    this.processBars();

    window.addEventListener('resize', () => {
      this.processBars();
    });
  }

  processBars() {
    this.progressbars.forEach(el => {
      let innerBar = el.querySelector('.ns-progress-bar__percentage');
      let percentage = innerBar.textContent;
      if ( percentage === "" ) {
        percentage = innerBar.dataset.percentage;
      }
      if ( !percentage.includes('%') ) {
        percentage += "%";
      }
      if ( !innerBar.dataset.percentage ) {
        innerBar.dataset.percentage = percentage;
      }
      innerBar.style.width = "calc(" + percentage + " + 2px)";

      if ( innerBar.offsetWidth < 60 ) {
        innerBar.dataset.percentage = percentage;
        innerBar.textContent = "";
      } else {
        innerBar.dataset.percentage = "";
        innerBar.textContent = percentage;
      }
    });
  }

}

export default Progressbar;
